import { render, staticRenderFns } from "./IconAwardLeaderBoard.vue?vue&type=template&id=3e491187"
import script from "./IconAwardLeaderBoard.vue?vue&type=script&lang=js"
export * from "./IconAwardLeaderBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports